import { styled } from '../../styles/settings'

const DivisionLogo = styled.img`
  height: auto;
  width: 3rem;
`

export default DivisionLogo
